import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MapPin } from 'lucide-react';
import { useWhatsApp } from '../../context/WhatsAppContext';

export default function CitySelectionModal() {
  const { isModalOpen, closeWhatsAppModal, cities } = useWhatsApp();

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  if (!isModalOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="relative w-full max-w-md p-6 overflow-hidden rounded-2xl border border-[#cbd5e1] shadow-2xl bg-white"
        >
          <button
            onClick={closeWhatsAppModal}
            className="absolute top-4 right-4 p-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="text-center mb-8 mt-2">
            <h3 className="text-xl font-poppins font-bold text-foreground mb-2">
              Selecione sua cidade
            </h3>
            <p className="text-sm text-muted-foreground">
              Para um atendimento personalizado, por favor,
              <br />
              escolha sua cidade.
            </p>
          </div>

          <div className="space-y-3">
            {cities.map((city, index) => (
              <a
                key={city.name}
                href={`https://wa.me/${city.whatsapp}?text=Olá! Gostaria de mais informações sobre os planos da WebNorte.`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeWhatsAppModal}
                className="flex items-center justify-center w-full gap-2 px-4 py-4 rounded-xl text-white font-medium hover:opacity-90 transition-opacity bg-primary"
              >
                <MapPin className="w-5 h-5" />
                {city.name}
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
